import type { ReactElement } from 'react'
import styled from 'styled-components'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { AHeading, CHeading } from '@/components/layouts/Ir/Heading'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'

export const InternalControlPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Internal Control Structure"
        subTitleText="内部統制システムに関する基本方針"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>内部統制システムの整備の状況</AHeading>
        <Paragraph>
          当社は、内部統制システムの適切な構築・運用が業務執行の公正性及び効率性を確保するのに重要な経営課題であるとの認識から、取締役会において内部統制システムに関する基本方針を決議しております。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <CHeading>
          1. 取締役の職務の執行が法令及び定款に適合することを確保するための体制
        </CHeading>
        <List>
          <Paragraph>
            (1)
            取締役は、当社及び当社子会社等（以下「当社グループ」という。）が共有すべきルールや考え方を表した「TRIAL の行動指針」を通じて、トライアルグループにおける企業倫理の確立並びにその遵守の重要性につき繰り返し情報発信することにより、その周知徹底を図る。
          </Paragraph>
          <Paragraph>
            (2)
            取締役会は社外取締役を含む取締役で構成し、法令、定款及び「取締役会規程」その他の社内規程等に従い、重要事項を決定するとともに、取締役の職務の執行を監督する。
          </Paragraph>
          <Paragraph>
            (3)
            監査役は、「監査役会規程」及び「監査役監査基準」に則り、取締役の職務執行の適正性を監査する。
          </Paragraph>
        </List>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          2. 取締役の職務の執行に係る情報の保存及び管理に関する体制
        </CHeading>
        <List>
          <Paragraph>
            (1)
            情報セキュリティについては、「情報セキュリティポリシー」及び「情報セキュリティポリシー運用規程」に基づき、情報セキュリティに関する責任体制を明確化し、情報セキュリティの維持・向上のための施策を継続的に実施する情報セキュリティマネジメントの実施体制を確立する。情報セキュリティ委員会で審議し、当社グループ全体で横断的に推進する。
          </Paragraph>
          <Paragraph>
            (2)
            取締役、執行役員及び使用人がその職務の執行をするにあたり必要とされる稟議書、株主総会議事録、取締役会議事録その他の文書を当社の社内規程に従い作成する。
          </Paragraph>
          <Paragraph>
            (3)
            作成した文書（電磁的情報を含む）は文書管理規程に従い、保存及び管理をする。
          </Paragraph>
        </List>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>3. 損失の危険の管理に関する規程その他の体制</CHeading>
        <Paragraph>
          当社は、損失の危険の未然防止及び危機発生時の被害最小化を担うグループリスクコンプライアンス委員会の設置及び「グループリスク管理規程」を策定し、損失リスク及び被害の低減に努める。また、事業部門ごとにリスクアセスメントを実施し、当社グループ全体の損失の危険を管理することを通じて、ステークホルダーに対する安心・安全の提供及びブランド価値の毀損防止はもとより、企業価値の向上にも努める。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          4. 取締役の職務の執行が効率的に行われることを確保するための体制
        </CHeading>
        <List>
          <Paragraph>
            (1)
            取締役会を月1回開催するほか、必要に応じて適宜臨時に開催し、取締役の執行状況については四半期に1回取締役会に報告する。
          </Paragraph>
          <Paragraph>
            (2)
            業務執行については、あらかじめ定められた「業務分掌規程」、「職務権限規程」、「関係会社管理規程」により、それぞれの業務執行において必要となる権限を付与して経営責任を明確化する。
          </Paragraph>
          <Paragraph>
            (3)
            当社はグループの中期経営計画を定め、当社グループの役職員に浸透を図るとともに、その実現に向け、事業分野別の目標数値を設定する。
          </Paragraph>
        </List>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          5. 使用人の職務の執行が法令及び定款に適合することを確保するための体制
        </CHeading>
        <List>
          <Paragraph>
            (1) 当社は、「TRIAL の行動指針」を制定・施行し、使用人一人ひとりがコンプライアンスの重要性を認識し、お客様をはじめ、お取引先・株主・従業員等の当社グループをとりまくステークホルダーの要望に応えるため、法令等を遵守するよう徹底を図る。
          </Paragraph>
          <Paragraph>
            (2)
            代表取締役の直轄部署として内部監査室を設置し、内部監査を実施する。内部監査室監査により法令・定款及び社内規程に違反する事項が発見された場合、内部監査室は直ちに代表取締役社長に報告する。
          </Paragraph>
          <Paragraph>
            (3)
            使用人が法令・定款及び社内規程に違反する行為を発見した場合には、コンプライアンス推進者に通報できる社内体制を整備する。
          </Paragraph>
        </List>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          6. 当社グループにおける業務の適正を確保するための体制
        </CHeading>
        <List>
          <Paragraph>
            (1)
            取締役が、自己又は親会社、子会社、その他第三者のために当社と利益が実質的に相反するおそれのある取引を行う場合、取締役会でその取引内容の詳細について審議したうえ、取締役会で承認を得てから実施をする。
          </Paragraph>
          <Paragraph>
            (2)
            当社の役員や主要株主など関連当事者と取引を行う場合は、「関連当事者等取引管理規程」に則り、関連当事者等取引検討委員会でその取引内容の詳細について審議したうえ、取締役会で承認を得てから担当部門は取引を実施する。なお、年１回各関連当事者等との年間取引実績の報告を行い、取引の合理性・相当性の精査を行う。取引に関する取締役会決議を行う場合は、当該取引に利害関係を有する取締役を特別利害関係人として除外したうえで決議するなどして、手続きの公正性を確保する。
          </Paragraph>
          <Paragraph>
            (3)
            内部監査室は、当社グループの業務の適正性について監査を行う。ただし、内部監査部門を有する子会社については、当該部門と連携して行う。
          </Paragraph>
        </List>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          7.
          監査役がその職務を補助すべき使用人を置くことを求めた場合における当該使用人に関する事項、並びに補助使用人の当社取締役からの独立性に関する事項及び当該使用人に対する指示の実効性の確保に関する事項
        </CHeading>
        <List>
          <Paragraph>
            (1)
            専属の使用人は設置せず、監査役は内部監査室長と協議のうえ、内部監査室所属のスタッフに監査業務に必要な事項を命令できるものとする。
          </Paragraph>
          <Paragraph>
            (2)
            前項によって指名されたスタッフへの指揮命令権は監査役に移譲されたものとし、取締役、内部監査室等からの指揮命令は受けないものとする。
          </Paragraph>
        </List>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          8.
          取締役及び使用人が監査役に報告をするための体制その他の監査役への報告に関する体制
        </CHeading>
        <List>
          <Paragraph>
            (1)
            取締役及び使用人は、監査役の求めに応じて、随時その職務の執行状況その他に関する報告を行う。
          </Paragraph>
          <Paragraph>
            (2)
            監査役は、取締役会、グループリスクコンプライアンス委員会その他の重要な会議に出席し、取締役等からその職務執行状況を聴取し、関係資料を閲覧することができる。
          </Paragraph>
          <Paragraph>
            (3)
            当社は、子会社の取締役、執行役員及び使用人が、監査役の求めに応じて、随時その職務の執行状況その他に関する報告を行うよう指導する。
          </Paragraph>
          <Paragraph>
            (4)
            使用人は、監査役に対して、当社に著しい損害を及ぼすおそれがある事実等を直接報告できるものとする。
          </Paragraph>
        </List>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          9.
          監査役に報告を行った者が当該報告をしたことを理由として不当な取扱いを受けないことを確保するための体制
        </CHeading>
        <Paragraph>
          「内部通報規程」において、上記により監査役に対して報告を行った者に対する不利益取扱いを禁止する旨明記し、十分周知する。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          10.
          監査役の職務の執行について生ずる費用の前払又は償還の手続きその他の当該職務の執行について生ずる費用又は債務の処理に係る方針に関する事項
        </CHeading>
        <Paragraph>
          監査役がその職務の執行について、当社に対し、会社法第388条に基づく費用の前払い等の請求をしたときは、担当部署において確認のうえ、速やかに当該費用又は債務を処理する。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 50 }} />
        <CHeading>
          11. その他監査役の監査が実効的に行われることを確保するための体制
        </CHeading>
        <List>
          <Paragraph>
            (1)
            監査役は、取締役会に出席するほか、必要と認める重要な会議に出席する。
          </Paragraph>
          <Paragraph>
            (2)
            監査役は月１回定時に監査役会を開催するほか、必要に応じて臨時に開催し、監査実施状況等について情報交換及び協議を行うとともに、会計監査人から定期的に会計監査に関する報告を受け、意見交換を行う。
          </Paragraph>
          <Paragraph>
            (3)
            内部監査室は、監査役との間で、各事業年度の内部監査計画の策定、内部監査結果等につき、密接な情報交換及び連携を図る。
          </Paragraph>
          <Paragraph>
            (4)
            監査役は、監査の実施にあたり必要と認めるときは、外部専門家を独自に起用することができる。
          </Paragraph>
        </List>
        <Spacer h={{ sp: 70, pc: 100 }} />
        <AHeading>リスク管理体制の整備の状況</AHeading>
        <Paragraph>
          リスク管理体制につきましては、リスクを未然に予防することを含め、各業務部門における業務・経営・市場・信用等のあらゆる面のリスクを捉え、自然災害から人為的なリスク、社内外でのリスク等を正確に把握、分析、対処していく体系的なリスク管理体制の整備に取組んでおります。
        </Paragraph>
        <Paragraph>
          また、グループリスクコンプライアンス委員会においてコンプライアンス体制の遵守状況に対する確認を四半期に１回定期的に開催し、各業務部門における法令遵守及びリーガルリスク回避の徹底を図り、取締役会に報告しております。
        </Paragraph>
      </section>
    </Layout>
  )
}

InternalControlPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir/' },
    { name: 'コーポレート・ガバナンス', path: '/ir/governance/' },
    { name: '内部統制システムに関する基本方針', path: '' },
  ]

  return (
    <>
      <Head
        title="内部統制システムに関する基本方針"
        description=" トライアルホールディングスの内部統制システム及びリスク管理体制の整備の状況について掲載しています。"
        ogp={{ url: 'ir/governance/internal-control/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
